module.exports = __webpack_public_path__ + "img/6ed4f33.jpg";